const toExport = { window: (typeof window !== 'undefined' && window) || {} };

export default toExport;
